import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { CommonService } from '../services/common.service';

interface CustomTag {
  start: string;
  end: string;
  regexStart: RegExp;
  regexEnd: RegExp;
  htmlStart: string;
  htmlEnd: string;
}

@Pipe({
  name: 'convertTrustedVrmHtml',
})
export class TrustAndConvertVrmHtmlPipe implements PipeTransform {
  companyColor: string = '#' + this.cService.userProfile.HqColour;

  constructor(private domSanitizer: DomSanitizer, private cService: CommonService) {}

  supportedTags: Array<CustomTag> = [
    {
      start: '[b]',
      end: '[.b]',
      regexStart: /\[b\]/,
      regexEnd: /\[.b\]/,
      htmlStart: '<b>',
      htmlEnd: '</b>',
    },
    {
      start: '[i]',
      end: '[.i]',
      regexStart: /\[i\]/,
      regexEnd: /\[.i\]/,
      htmlStart: '<i>',
      htmlEnd: '</i>',
    },
    {
      start: '[u]',
      end: '[.u]',
      regexStart: /\[u\]/,
      regexEnd: /\[.u\]/,
      htmlStart: '<u>',
      htmlEnd: '</u>',
    },
    {
      start: '[a]',
      end: '[.a]',
      regexStart: /\[a\]/,
      regexEnd: /\[.a\]/,
      htmlStart: '<a>',
      htmlEnd: '</a>',
    },
    {
      start: '[p]',
      end: '[.p]',
      regexStart: /\[p\]/,
      regexEnd: /\[.p\]/,
      htmlStart: '<p>',
      htmlEnd: '</p>',
    },
    {
      start: '[red]',
      end: '[.red]',
      regexStart: /\[red\]/,
      regexEnd: /\[.red\]/,
      htmlStart: `<span style="color: red">`,
      htmlEnd: '</span>',
    },
    {
      start: '[green]',
      end: '[.green]',
      regexStart: /\[green\]/,
      regexEnd: /\[.green\]/,
      htmlStart: `<span style="color: green">`,
      htmlEnd: '</span>',
    },
    {
      start: '[blue]',
      end: '[.blue]',
      regexStart: /\[blue\]/,
      regexEnd: /\[.blue\]/,
      htmlStart: `<span style="color: blue">`,
      htmlEnd: '</span>',
    },
    {
      start: '[orange]',
      end: '[.orange]',
      regexStart: /\[orange\]/,
      regexEnd: /\[.orange\]/,
      htmlStart: `<span style="color: orange">`,
      htmlEnd: '</span>',
    },
    {
      start: '[black]',
      end: '[.black]',
      regexStart: /\[black\]/,
      regexEnd: /\[.black\]/,
      htmlStart: `<span style="color: black">`,
      htmlEnd: '</span>',
    },
    {
      start: '[company]',
      end: '[.company]',
      regexStart: /\[company\]/,
      regexEnd: /\[.company\]/,
      htmlStart: `<span style="color: ${this.companyColor}">`,
      htmlEnd: '</span>',
    },
  ];

  attribute = {
    identifier: '>[attr]',
    identifierRegex: /\>\[attr\]/,
    identifierReplacement: ' ',

    demarcatorStart: '||',
    demarcatorStartRegex: /\|\|/,
    demarcatorStartReplacement: '"',

    demarcatorEnd: '|.|',
    demarcatorEndRegex: /\|\.\|/,
    demarcatorEndReplacement: '">',
  };

  transform(text: string) {
    let cleanHtml = text.replace(/(<([^>]+)>)/gi, ''); // <-- attempt to remove already injected HTML

    this.supportedTags.forEach((tag: CustomTag) => {
      if (text.includes(tag.start) && text.includes(tag.end)) {
        const startRegex = new RegExp(tag.regexStart, 'g');
        const endRegex = new RegExp(tag.regexEnd, 'g');

        cleanHtml = cleanHtml.replace(startRegex, tag.htmlStart).replace(endRegex, tag.htmlEnd);
      }
    });

    if (cleanHtml.includes(this.attribute.identifier)) {
      cleanHtml = this.processAttributes(cleanHtml);
    }

    cleanHtml = <string>this.domSanitizer.bypassSecurityTrustHtml(cleanHtml);

    return cleanHtml;
  }

  private processAttributes(cleanHtmlWithAttr: string): string {
    const identifierRegex = new RegExp(this.attribute.identifierRegex, 'g');
    const demarcatorStartRegex = new RegExp(this.attribute.demarcatorStartRegex, 'g');
    const demarcatorEndRegex = new RegExp(this.attribute.demarcatorEndRegex, 'g');

    let htmlWithAttr = cleanHtmlWithAttr.replace(identifierRegex, this.attribute.identifierReplacement);
    htmlWithAttr = htmlWithAttr.replace(demarcatorStartRegex, this.attribute.demarcatorStartReplacement);
    htmlWithAttr = htmlWithAttr.replace(demarcatorEndRegex, this.attribute.demarcatorEndReplacement);

    // NOTE: When external injection of http:// is detected in Angular,
    // spaces are injected to thwart the URL, hence the following
    htmlWithAttr = htmlWithAttr.replace(/ \/ /g, '/');

    return htmlWithAttr;
  }
}
